<div
  class="d-flex align-items-center justify-content-between label-value-v2-container"
>
  <span class="title">{{ title }}</span>
  <label
    class="value mb-0"
    [nbTooltip]="value"
    [nbTooltipDisabled]="type === 'userDate' || !value || value === 'N/A'"
  >
    <ng-container *ngIf="type === 'string'">
      {{ [null, undefined]?.includes(value) ? '-' : value }}
    </ng-container>
    <ng-container *ngIf="type === 'date'">{{
      value ? (value | timeago) : '-'
    }}</ng-container>
    <ng-container *ngIf="type === 'userDate'">
      <app-smart-table-timeago-tooltip
        [value]="value"
        class="timeago-with-user"
      ></app-smart-table-timeago-tooltip>
    </ng-container>
    <ng-container *ngIf="type === 'custom'">
      <ng-template
        appDynamicComponent
        [componentName]="customComponent"
        [componentInputs]="customInputs"
        (componentOutput)="handleComponentOutput($event)"
      ></ng-template>
    </ng-container>
  </label>
</div>
